{
  "download": "Download",
  "delete_file": "Delete file",
  "delete_file_text": "This action is irreversible",
  "uploaded_by": "Uploaded by",
  "rent_period": "Rent period",
  "add_equipment": "Add equipment",
  "search": "Search"
}
